import React, { useEffect } from "react";
import "./styles/index.scss";
import { Routes, Route } from "react-router-dom";
//import { Routes, Route } from "react-router";

import NotFound from "./components/NotFound";
import Cgu from "./components/cgu";
import Footer from "./components/Footer";
import Home from "./components/home";
import Info from "./components/Info";

import FormBis from "./components/formBis";
import ConsulterResa from "./components/consulterResa";
import LinkResa from "./components/linkResa";
import ConsulterResaAdmin from "./components/ConsulterResaAdmin";

import AOS from "aos";
import "aos/dist/aos.css";
import MentionsLegales from "./components/MentionsLegales";
function App() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-quart",
      once: true,
    });
  }, []);
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/réserver" element={<FormBis />} />

        <Route path="/mentions-legales" element={<MentionsLegales />} />

        <Route path="/consultation-reservation" element={<ConsulterResa />} />
        <Route
          path="/consultation-reservation/admin"
          element={<ConsulterResaAdmin />}
        />
        <Route path="/lien-reservation/*" element={<LinkResa />} />
        <Route path="/cgu" element={<Cgu />} />
        <Route path="/info" element={<Info />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
